import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../components/base/Loading';
import ProviderSelector from '../components/tasks/ProviderSelector';
import TaskDefinitionForm from '../components/tasks/TaskDefinitionForm';
import useTaskManager from '../context/taskManager/useTaskManager';
import { Provider, useGetTaskDefinitionQuery } from '../graphql/schema';
import TaskDefinitionHeader from '../components/tasks/TaskDefinitionHeader';

const CreateTask = () => {
  const { taskDefinitionId } = useParams();
  const navigate = useNavigate();
  const { createTaskFromTaskDefinition } = useTaskManager();

  const { data, loading } = useGetTaskDefinitionQuery({
    variables: {
      id: taskDefinitionId ?? '',
    },
    skip: !taskDefinitionId,
    fetchPolicy: 'no-cache',
  });

  const [selectedProvider, setSelectedProvider] = useState<Provider>();
  const [createTaskLoading, setCreateTaskLoading] = useState<boolean>(false);

  const handleSubmit = useCallback(
    async (formValues: any) => {
      if (!selectedProvider || !taskDefinitionId) return;

      setCreateTaskLoading(true);

      const task = await createTaskFromTaskDefinition(
        taskDefinitionId,
        selectedProvider.gatewayId,
        formValues,
      );

      if (task) navigate(`/task/${task.id}`);
    },
    [
      taskDefinitionId,
      selectedProvider,
      createTaskFromTaskDefinition,
      navigate,
    ],
  );

  useEffect(() => {
    if (
      data?.taskDefinition.usableProviders &&
      data?.taskDefinition.usableProviders.length > 0
    ) {
      setSelectedProvider(data?.taskDefinition.usableProviders[0]);
    }
  }, [data]);

  if (loading) return <Loading />;

  return (
    <div>
      {data?.taskDefinition && (
        <div className="p-5 flex justify-center">
          <div className="bg-white w-full rounded-xl p-5 shadow max-w-[1200px]">
            <TaskDefinitionHeader taskDefinition={data.taskDefinition}>
              {data?.taskDefinition.usableProviders &&
                data.taskDefinition.usableProviders.length > 1 && (
                  <div className="lg:absolute top-0 right-0 z-20">
                    <ProviderSelector
                      taskDefinition={data.taskDefinition}
                      selectProvider={setSelectedProvider}
                      selectedProvider={selectedProvider}
                    />
                  </div>
                )}
            </TaskDefinitionHeader>

            <TaskDefinitionForm
              schema={data?.taskDefinition.formDefinition}
              onSubmit={handleSubmit}
              saveButtonLabel="Los geht's"
              loading={createTaskLoading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateTask;
